<div>

  <!-- CARDS -->
  <div class="grid m-0 mb-3 mt-5">
    @for (card of cards; track $index){
      <!-- skeleton cards -->
      @if (cardsLoading) {
        <div class="col px-1" style="cursor: pointer;">
          <div class="flex align-items-center p-4 border-round-lg shadow-6 customBorder">
            <div class="ml-1 mr-5">
              <p-skeleton shape="circle" width="4.26rem" height="4.26rem" />
            </div>
            <div class="flex flex-column">
              <div class="mb-1">
                <p-skeleton width="4.26rem" height="2rem" />
              </div>
              <div>
                <p-skeleton width="4.26rem" height="1.2rem" />
              </div>
            </div>
          </div>
        </div>
      }@else {
        <!-- cards component -->
        <app-dashboard-card class="col px-1" style="cursor: pointer;" [data]="card"></app-dashboard-card>
      }
    }
  </div>

  <!-- DATA & CHARTS -->
  <div class="grid m-0">

    <div class="col-12 xl:col-6 flex flex-column justify-content-between">
      <div class="border-round-lg shadow-6 customBorder p-4">
        <p class="text-center text-2xl font-semibold mb-3">{{ translate.instant('dashboard.riepilogo.titolo') }}</p>
        <div class="p-3">
          <p-table *ngIf="!yearsLoading" [value]="riepiloghi" [tableStyle]="{ 'min-height': '25.3rem' }">
            <ng-template pTemplate="header">
                <tr class="text-sm">
                    <th width="5%" class="text-center text-white bg-albo border-round-top-xl px-3 pt-3"><i class="pi pi-calendar text-xl"></i></th>
                    <th class="text-center">{{ translate.instant('dashboard.riepilogo.tot') }}</th>
                    <th class="text-center">{{ translate.instant('dashboard.riepilogo.sezionaA') }}</th>
                    <th class="text-center">{{ translate.instant('dashboard.riepilogo.sezionaB') }}</th>
                    <th class="text-center">{{ translate.instant('dashboard.riepilogo.sospesi') }}</th>
                    <th class="text-center">{{ translate.instant('dashboard.riepilogo.stp') }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-riepilogo>
                <tr class="text-lg">
                    <td class="px-3 text-center text-white bg-albo {{ riepilogo.anno === annoPiccolo ? 'border-round-bottom-xl' : '' }}">
                      {{ riepilogo.anno }}
                    </td>
                    <td class="text-center">{{ riepilogo.totaleIscritti }}</td>
                    <td class="text-center">{{ riepilogo.iscrittiSezioneA }}</td>
                    <td class="text-center">{{ riepilogo.iscrittiSezioneB }}</td>
                    <td class="text-center">{{ riepilogo.sospesi }}</td>
                    <td class="text-center">{{ riepilogo.stp }}</td>
                </tr>
            </ng-template>
          </p-table>

          <div *ngIf="yearsLoading" class="pt-2">
            <p-skeleton width="100%" height="1.7rem" styleClass="mb-5"></p-skeleton>
            <p-skeleton width="100%" height="1.7rem" styleClass="mb-5"></p-skeleton>
            <p-skeleton width="100%" height="1.7rem" styleClass="mb-5"></p-skeleton>
            <p-skeleton width="100%" height="1.7rem" styleClass="mb-5"></p-skeleton>
            <p-skeleton width="100%" height="1.7rem" styleClass="mb-5"></p-skeleton>
            <p-skeleton width="100%" height="1.7rem" styleClass="mb-5"></p-skeleton>
            <p-skeleton width="100%" height="1.6rem" styleClass="mb-3"></p-skeleton>
          </div>

        </div>
      </div>
    </div>

    <div class="col-6 hidden xl:block">
      <div class="backroundBlue border-round-lg shadow-6 customBorder py-4">
        <div class="pt-2 mb-5">
          <p class="text-center text-2xl font-semibold">{{ translate.instant('dashboard.analitica.titolo') }} {{ labelRegionale }}</p>
        </div>
        <div class="flex justify-content-center py-2">
          <!-- grafico sesso -->
          <div class="flex justify-content-center mr-4">
            <p-chart type="doughnut" [data]="dataSesso" [options]="optionsSesso" width="14vw" height="397px"></p-chart>
          </div>
          <!-- grafico età -->
          <div class="flex justify-content-center ml-4">
            <p-chart type="doughnut" [data]="dataEta" [options]="optionsEta" width="14.3vw" height="397px"></p-chart>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 xl:hidden">
      <div class="backroundBlue border-round-lg shadow-6 customBorder py-4">
        <div class="pt-2 mb-5">
          <p class="text-center text-2xl font-semibold">Analitica Iscritti Albo Psicologi {{ labelRegionale }}</p>
        </div>
        <div class="flex justify-content-center py-2">
          <!-- grafico sesso -->
          <div class="flex justify-content-center mr-4">
            <p-chart type="doughnut" [data]="dataSesso" [options]="optionsSesso" width="30vw" height="398px"></p-chart>
          </div>
          <!-- grafico età -->
          <div class="flex justify-content-center ml-4">
            <p-chart type="doughnut" [data]="dataEta" [options]="optionsEta" width="30vw" height="398px"></p-chart>
          </div>
        </div>
      </div>
    </div>

  </div>

  @if(regioniAnaliticaInformazioniIscritti){
    <div class="grid m-0">
      <div class="col-12">
        <div class="backroundBlue border-round-lg shadow-6 customBorder py-4">
          <div class="pt-2 mb-5">
            <p class="text-center text-2xl font-semibold">{{ translate.instant('dashboard.analiticaInfo.titolo') }}</p>
          </div>
          <div class="flex justify-content-center py-2">
            <!-- grafico titoli -->
            <div class="flex justify-content-center mr-4">
              <p-chart type="doughnut" [data]="dataTitoli" [options]="optionsTitoli" width="25vw" height="398px"></p-chart>
            </div>
            <!-- grafico regioni -->
            <div class="flex justify-content-center">
              <p-chart type="doughnut" [data]="dataRegioni" [options]="optionsRegioni" width="25vw" height="398px"></p-chart>
            </div>
            <!-- grafico province -->
            <div class="flex justify-content-center ml-4">
              <p-chart type="doughnut" [data]="dataProvince" [options]="optionsProvince" width="25vw" height="398px"></p-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  }


  <p-toast position="bottom-center"></p-toast>

</div>
